import { Moment } from "moment-timezone";
import { AnyPeriod, toGQLDate } from "@ct-react/core";
import { BookingOption, isBookingPrice } from "@ct-react/calendar";
import { AgeCategory, CartOptionType } from "@shared/graphql";

type CheckoutParams = {
  articleId: string;
  period: AnyPeriod;
  guests: Record<AgeCategory, number>;
}

export const parse = (params: URLSearchParams): CheckoutParams => {

  const start = params.get("b_in")!;
  const end = params.get("b_out")!;

  return {
    articleId: params.get("id")!,
    period: [ start, end ],
    guests: {
      ...(params.has("o_guest_a")) && { [AgeCategory.ADULT]: +params.get("o_guest_a")! },
      ...(params.has("o_guest_b")) && { [AgeCategory.BABY]: +params.get("o_guest_b")! },
      ...(params.has("o_guest_c")) && { [AgeCategory.CHILD]: +params.get("o_guest_c")! },
      ...(params.has("o_guest_e")) && { [AgeCategory.EXEMPT]: +params.get("o_guest_e")! },
      ...(params.has("o_guest_s")) && { [AgeCategory.SENIOR]: +params.get("o_guest_s")! },
    } as Record<AgeCategory, number>
  }

}

export const rebuild = (articleId: string, option: BookingOption<Moment>, params: URLSearchParams = new URLSearchParams()): URLSearchParams => {

  params.set("id", articleId);
  params.set("b_in", toGQLDate(option.period.start));
  params.set("b_out", toGQLDate(option.period.end));

  if (!isBookingPrice(option.price))
    return params;

  const taxes = option.price.detailed.extras?.find(extra => extra.type === CartOptionType.TOURIST_TAX);
  if (!!taxes)
    taxes.data.participantsCount.forEach(({ ageCategory, number }: any) => {
      if (number < 1) return;
      const key = `o_guest_${ageCategory.charAt(0).toLowerCase()}`;
      params.set(key, number.toString());
    });

  return params;

}

export const rebuildGuestsOnly = (guests: Record<AgeCategory, number> | undefined, params: URLSearchParams): URLSearchParams => {

  Array.from(params.keys()).filter(pk => pk.match(/^o_guest_/)).forEach(pk => params.delete(pk));

  Object.entries(guests || {}).forEach(([ ageCategory, number ]) => {
    if (number < 1) return;
    const key = `o_guest_${ageCategory.charAt(0).toLowerCase()}`;
    params.set(key, number.toString());
  });

  return params;

}
